import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CategoryCard({
  title,
  description,
  image,
  link,
}) {
  return (
    <Link
      to={link}
      className="group relative overflow-hidden rounded-3xl"
    >
      {/* Image */}
      <div className="overflow-hidden rounded-3xl">
        <img
          src={image}
          alt={title}
          className="h-[420px] w-full object-cover transition duration-700 group-hover:scale-110"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 p-8 text-white">

        <p className="text-sm uppercase tracking-[3px] opacity-80">
          Collection
        </p>

        <h2 className="mt-2 text-3xl font-semibold">
          {title}
        </h2>

        <p className="mt-3 text-sm leading-6 opacity-90">
          {description}
        </p>

        <div className="mt-6 flex items-center gap-2 font-medium">

          Explore

          <ArrowRight
            size={18}
            className="transition-transform duration-300 group-hover:translate-x-2"
          />

        </div>

      </div>

    </Link>
  );
}